/**
 * #108 — niveau d'accès d'une affaire côté front.
 *
 * L'API joint `access: { level, canChangeProjectManager }` à chaque affaire
 * (`full` ADMIN, `delegated` responsable client / PM / manager hiérarchique du
 * PM, `read` membre). Le front ne fait que refléter ce niveau : l'autorité
 * reste le serveur, qui refuse toute écriture hors périmètre.
 */
export function affaireLevel(affaire, isAdmin) {
  if (isAdmin) return 'full';
  return affaire?.access?.level ?? 'read';
}
